import { render, staticRenderFns } from "./HomeSwiperUpload.vue?vue&type=template&id=4f55a82b&scoped=true&"
import script from "./HomeSwiperUpload.vue?vue&type=script&lang=js&"
export * from "./HomeSwiperUpload.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwiperUpload.vue?vue&type=style&index=0&id=4f55a82b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55a82b",
  null
  
)

export default component.exports